/// <reference path="../include.ts" />

namespace project_common {

	export class CommonLocalizable {

		// Common
		public static readonly loadErrorTitle:Localizable<string> = {
			"ja"     : "データの読み込みに失敗しました。",
			"en"     : "The data could not be loaded.",
			"ko"     : "데이터의 로딩에 실패했습니다.",
			"th"     : "อ่านข้อมูลไม่สำเร็จ",
			"zh-hans": "无法载入数据。",
			"zh-hant": "資料讀取失敗。",
		};

		public static readonly loadErrorDescription:Localizable<string> = {
			"ja"     : "インターネットの接続が良い場所で再読み込みをしてください。",
			"en"     : "Please refresh again at a location with a more stable Internet connection.",
			"ko"     : "인터넷 연결이 잘 되는 곳에서 새로고침을 해 주세요.",
			"th"     : "กรุณาโหลดใหม่ในสถานที่ที่มีการเชื่อมต่ออินเทอร์เน็ตที่ดี",
			"zh-hans": "请确保网络连接状况良好，再刷新本页面。",
			"zh-hant": "請在網路的環境良好的地點重新讀取。",
		};

		public static readonly loadErrorAction:Localizable<string> = {
			"ja"     : "再読み込み",
			"en"     : "Refresh",
			"ko"     : "새로고침",
			"th"     : "โหลดใหม่",
			"zh-hans": "刷新",
			"zh-hant": "重新讀取",
		};

		// Guide
		public static readonly drawerOpenButtonLabel:Localizable<string> = {
			"ja"     : "ゾーン",
			"en"     : "Zone",
			"ko"     : "존",
			"th"     : "โซน",
			"zh-hans": "区域",
			"zh-hant": "區域",
		};

		public static readonly cardViewCloseButtonLabel:Localizable<string> = {
			"ja"     : "展示種一覧",
			"en"     : "List of Exhibits",
			"ko"     : "전시종 목록",
			"th"     : "รายชื่อพันธุ์ที่จัดแสดง",
			"zh-hans": "展品种类一览",
			"zh-hant": "展示物種一覽表",
		};

		public static readonly cameraDescription:Localizable<string> = {
			"ja"     : "この水槽には水中カメラが設置されています",
			"en"     : "This water tank is equipped with an underwater camera.",
			"ko"     : "이 수조에는 수중 카메라가 설치되어 있습니다.",
			"th"     : "มีการติดตั้งกล้องใต้น้ำในแทงก์น้ำนี้",
			"zh-hans": "此水槽内设有水下相机。",
			"zh-hant": "這個水槽內設有水中攝影機。",
		};





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
